/* [PATCH nastavitve-zavihki v1] preseljeno 1:1 iz ProfilPage.tsx:
   state zbVklop/zbPartnerId/zbNaziv/zbSifra/zbSpor (27-47) + JSX (403-427).
   [PATCH zbirni-kupec v1] lastno shranjevanje GET/PUT /companies/{id}/zbirni-kupec
   ostane — kartica se shranjuje sproti, neodvisno od gumba Shrani. */
import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';
import { api } from '../../lib/api';
import { PlacnikPartnerVnos } from '../PlacnikPartnerVnos';

export function ZbirniKupecKartica({ companyId }: { companyId: string }) {
  const [zbVklop, setZbVklop] = useState(false);
  const [zbPartnerId, setZbPartnerId] = useState('');
  const [zbNaziv, setZbNaziv] = useState('');
  const [zbSifra, setZbSifra] = useState('');
  const [zbSpor, setZbSpor] = useState('');

  useEffect(() => {
    if (!companyId) return;
    setZbSpor('');
    api.get(`/companies/${companyId}/zbirni-kupec`)
      .then(r => { setZbVklop(!!r.data?.vklopljeno); setZbPartnerId(r.data?.partner_id || ''); setZbNaziv(r.data?.partner_naziv || ''); setZbSifra(r.data?.partner_sifra || ''); })
      .catch(() => {});
  }, [companyId]);

  const zbShrani = async (vklopljeno: boolean, partner_id: string) => {
    setZbSpor('');
    try {
      const r = await api.put(`/companies/${companyId}/zbirni-kupec`, { vklopljeno, partner_id });
      setZbVklop(!!r.data?.vklopljeno);
      if (r.data?.vklopljeno) { setZbPartnerId(r.data?.partner_id || ''); setZbNaziv(r.data?.partner_naziv || ''); setZbSifra(r.data?.partner_sifra || ''); }
      setZbSpor(r.data?.vklopljeno ? 'Shranjeno.' : 'Izklopljeno.');
    } catch (e: any) { setZbSpor(e?.response?.data?.detail || 'Shranjevanje ni uspelo.'); }
  };

  return (
    <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-blue-50 dark:bg-blue-900/30 text-blue-600 flex items-center justify-center">
          <Users className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-white">Zbirni kupec (brez davčne)</h2>
          <p className="text-xs text-gray-500">Kupci brez davčne številke se ob uvozu izdanih računov vežejo na izbranega zbirnega kupca; ime osebe se zapiše v opis dokumenta. Kupci z davčno gredo po običajni poti. Nastavitev se shrani sproti (neodvisno od gumba Shrani).</p>
        </div>
      </div>
      <div className="mt-4 space-y-4">
        <div className="flex items-start gap-3">
          <button type="button"
            onClick={() => { if (zbVklop) { zbShrani(false, zbPartnerId || ''); } else if (zbPartnerId) { zbShrani(true, zbPartnerId); } else { setZbSpor('Najprej izberi zbirnega kupca v polju spodaj.'); } }}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${zbVklop ? 'bg-blue-600' : 'bg-gray-300 dark:bg-gray-600'}`}
          >
            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${zbVklop ? 'translate-x-6' : 'translate-x-1'}`} />
          </button>
          <div className="flex-1">
            <div className="text-sm font-medium text-gray-900 dark:text-white">Kupce brez davčne veži na zbirnega kupca</div>
            {zbVklop && (
              <div className="text-xs text-emerald-700 dark:text-emerald-300 mt-1">Izbran: {zbSifra ? `${zbSifra} · ` : ''}{zbNaziv}</div>
            )}
          </div>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Zbirni kupec (iz šifranta partnerjev)</label>
          <PlacnikPartnerVnos companyId={companyId}
            partnerId={zbPartnerId} partnerNaziv={zbNaziv}
            onIzbira={(partner_id, partner_naziv) => { setZbPartnerId(partner_id); setZbNaziv(partner_naziv); zbShrani(true, partner_id); }} />
        </div>
        {zbSpor && <p className="text-[11px] text-gray-500">{zbSpor}</p>}
      </div>
    </div>
  );
}
